export const SUCCESS_STATUS = "OK";
export const ERROR_STATUS = "ERROR";
export const SUCCESS = "SUCCESS";

//  to prevent human error this can be used to disable all keys except numbers, dash, forward, and back
export const BAD_KEY_INPUTS = [
  8,
  37,
  39,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  189,
];

export const BANK_ACCOUNT_STATUS = {
  NO_PAYMENT_METHOD: "no payment method",
};

export const APPLICATION_STATUS = {
  APPROVED: "approved",
  PENDING: "pending",
  REJECTED: "rejected",
};

export const COMPLETION_STATUS = {
  APPROVED: "approved",
  AWAITING_USER_RESPONSE: "awaiting_user_response",
  NOT_STARTED: "not_started",
  PENDING: "pending",
  REJECTED: "rejected",
  STARTED: "started",
  TERMINATED: "terminated",
};

export const CARD_STATUS = {
  LOCKED: "LOCKED",
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  TERMINATED: "TERMINATED",
  UNKNOWN: "UNKNOWN",
};

export const ENROLLMENT_STATUS = {
  ELIGIBLE: "eligible",
  ENROLLED: "enrolled",
  WAITING: "waiting",
  TERMINATED: "terminated",
  LOCKED: "locked", // TODO: adjust to match backend
};

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SETTLED: "SETTLED",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
};

export const ACTIVITY_STATUS = {
  PENDING: "PENDING",
  SETTLED: "SETTLED",
  RETURNED: "RETURNED",
  CANCELED: "CANCELED",
  DISPUTED: "DISPUTED",
};

export const LOCK_TYPE = {
  RISK: "risk",
  RISK_INACTIVE: "risk_inactive",
  RISK_ACTIVE: "risk_active",
  FRAUD: "fraud_alert",
  TWOFA: "twoFa",
};

export const CARD_LOCKED_REASONS = {
  USER_INITIATED: ["user_lock"],
};

// Events
export const UNDERWRITING_RESULT = "UNDERWRITING_RESULT";
export const SUBMITTED_WITH_LOW_BALANCES = "SUBMITTED_WITH_LOW_BALANCES";

export const PAYMENT_AUTOPAY_INFO =
  "Your autopay amount will be for all settled transactions. Pending transactions will be included in next week’s payment.";

export const EMPTY_STRING = "";

export const DAYS_OF_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const PRODUCT_IDS = {
  CREDIT_BOOST: "credit_boost",
  CREDIT_MONITORING: "credit_monitoring",
};

export const PRODUCT_STATUS = {
  PENDING: "pending",
  TERMINATED: "terminated",
  ENROLLED: "enrolled",
  ELIGIBLE: "eligible",
};

export const PRODUCT_CANCELLATION_FEEDBACK = {
  too_expensive: "too_expensive",
  missing_features: "missing_features",
  switched_service: "switched_service",
  unused: "unused",
  customer_service: "customer_service",
  too_complex: "too_complex",
  low_quality: "low_quality",
  other: "other",
};

export const STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];